// Scroll up or down the page to an anchor

$(function () {

  // scrollto onpage
  $('a.scroll-to').on('click', function (e) {
    let hash = this.hash;

    if (hash !== "" && $(hash).length) {
      e.preventDefault();

      // set timeout for mobile so the mobile nav closes first
      let timeout = 0;

      if (window.innerWidth <= 1200) {
        timeout = 250;
      }

      setTimeout(() => {
        $('html, body').animate({
          scrollTop: ($(hash).offset().top) - ($('.jsNavbarFixed').outerHeight() || 0)
        },
          'slow',
          function () {
            history.pushState({}, "", hash)
          });
      }, timeout);
    }
  });


  // scrollto onload
  let hash = window.location.hash;
  if ($(hash).length) {
    // do not restore scroll position
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    $('html, body').scrollTop(($(hash).offset().top) - ($('.jsNavbarFixed').outerHeight() || 0));
  }

});